import { qsa } from "@fluorescent/dom";

import { emit } from "@/glow/events";

const filtering = container => {
  const forms = qsa("[data-filter-form]", container);
  let formData, searchParams;
  setParams();

  function setParams(form) {
    form = form || forms[0];
    formData = new FormData(form);
    searchParams = new URLSearchParams(formData).toString();
  }

  // Takes the updated form element and updates all other forms with the updated values
  // @param {*} target
  function syncForms(target) {
    if (!target) return;

    const targetInputs = qsa("[data-filter-item-input]", target);

    targetInputs.forEach(targetInput => {
      const { nameEscaped, valueEscaped } = targetInput.dataset;

      if (targetInput.type === "checkbox" || targetInput.type === "radio") {
        const items = qsa(
          `input[data-name-escaped='${nameEscaped}'][data-value-escaped='${valueEscaped}']`
        );
        items.forEach(input => {
          input.checked = targetInput.checked;
        });
      } else {
        const items = qsa(`input[data-name-escaped='${nameEscaped}']`);
        items.forEach(input => {
          input.value = targetInput.value;
        });
      }
    });
  }

  function clearRangeInputs() {
    const rangeInputs = qsa("[data-range-input]", container);
    rangeInputs.forEach(input => {
      input.value = "";
    });
  }

  function resetForms() {
    forms.forEach(form => {
      form.reset();
    });
  }

  return {
    getState() {
      return {
        url: searchParams,
      };
    },

    filtersUpdated(target, cb) {
      syncForms(target);
      setParams(target);
      emit("filters:updated");
      return cb(this.getState());
    },

    removeFilters(target, cb) {
      emit("filters:filter-removed");
      return cb({ url: target[0].getAttribute("data-url-to-remove") });
    },

    removeRange(cb) {
      clearRangeInputs();
      setParams();
      return cb(this.getState());
    },

    clearAll(cb) {
      searchParams = "";
      resetForms();

      return cb(this.getState());
    },
  };
};

export default filtering;
